export const environment = {
    alias: 'referentka-beta',
    firebaseProject: 'memowl',
    sentryDsn:
        'https://8d9b9acfd5dd3a3aa9e8068598771621@o4508794559070208.ingest.de.sentry.io/4508796286074960',
};
